import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 0.61, 0.36, 1];

/**
 * Scroll-triggered reveal wrapper. Slides in from below with a soft mask feel.
 */
export function Reveal({ children, delay = 0, y = 32, className = "", as: Tag = "div" }) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </MotionTag>
  );
}

/**
 * Line-by-line masked reveal used for editorial hero headlines.
 * Pass a string OR an array of strings for lines.
 */
export function MaskedLines({ lines, className = "", stagger = 0.12, delay = 0.05 }) {
  const arr = Array.isArray(lines) ? lines : [lines];
  return (
    <span className={className}>
      {arr.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className="mask-line-inner"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/**
 * Character-by-character reveal (used for eyebrows / numeric callouts).
 */
export function FadeUpText({ text, className = "", delay = 0 }) {
  return (
    <motion.span
      className={className}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {text}
    </motion.span>
  );
}
